import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import loadingGif from '../../assets/loadingGIF.gif';
import classes from './styles.module.scss';

const LoadingModal = ({ isVisible, code }) => {
    const { t } = useTranslation(['profile']);
    return (
        <div className={classes['vin-loading-wrapper']}>
            <Modal
                open={isVisible}
                footer={null}
                className={classes['vin-loading-modal']}
                closeIcon={false}
                maskClosable={false}
                centered
                width="auto"
            >
                <div className={classes['loading-content']}>
                    <img src={loadingGif} alt={t('profile:loading-message')} className={classes['loading-gif']} />

                    <div className={classes['vin-code-display']}>
                        <span>{code}</span>
                    </div>

                    <div className={classes['loading-text']}>
                        <h4 className={classes['loading-title']}>{t('profile:report-on-way')}</h4>
                        <p className={classes['loading-message']}>{t('profile:processing-vin-message')}</p>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

LoadingModal.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    code: PropTypes.string.isRequired,
};

export default LoadingModal;
